import { render, staticRenderFns } from "./QuickAddition.vue?vue&type=template&id=2f010087&scoped=true&"
import script from "./QuickAddition.vue?vue&type=script&lang=js&"
export * from "./QuickAddition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f010087",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f010087')) {
      api.createRecord('2f010087', component.options)
    } else {
      api.reload('2f010087', component.options)
    }
    module.hot.accept("./QuickAddition.vue?vue&type=template&id=2f010087&scoped=true&", function () {
      api.rerender('2f010087', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/fimalac/components/Modal/QuickAddition.vue"
export default component.exports